import { useState, useEffect, useRef } from "react";
import DataTable from "../../Common/DataTable/DataTable";
import { mcbAllTransactions, getUsersPartnerList, transactionReportDownload } from "../../api";
import { Spinner } from "react-bootstrap";
import download from "../../public/images/download.svg";
import { productType } from "../../utils/utils";
import CustomSpinner from "../../Common/Spinner";
import { formatDateAndTime } from "../../utils/utils";
import styles from "../../Component/Mcb/transaction.module.css";
import { Offcanvas, Row, Col, Card } from "react-bootstrap";
import { Accordion } from "react-bootstrap";
import SearchFilterBar from "../../Common/SearchFilter/SearchFilterBar";
import { Filter, Input } from "../../Common";
import { format } from "date-fns";
import { Button } from "../../Common";
import Result from "../../Common/V2/Widgets/Result";
import NoDataFound from "../../Common/V2/images/noDataFound";
import TransactionMainDetail from "../Mcb/TransactionMainDetail";
import TransactionOtherDetail from "../Mcb/TransactionOtherDetail";
import { CookieUtils } from "../../axios.config";
const TRANSACTION_NATURE = {
  FUND_RECEIVED: "CREDIT",
  REFUND: "CREDIT",
  REVERSAL: "CREDIT",
  CLEARING: "DEBIT",
  FEES: "DEBIT",
  FUND_TRANSFER: "CREDIT",
  FUND_TRANSFER_LIEN: "CREDIT",
  TRANSFER: "DEBIT",
  CHARGE: "DEBIT",
  AUTHORIZATION: "DEBIT",
  CONVERSION: "BOTH",
  FUND_RECEIVED_LIEN: "CREDIT"
};

const Transactions = () => {
  const timeoutRef = useRef(null);
  const [dataLoading, setDataLoading] = useState(false);
  const [transactionData, setTransactionData] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [error, setError] = useState(null);
  const [showCanvas, setShowCanvas] = useState(false);
  const [canvasData, setCanvasData] = useState(null);
  const [activeKey, setActiveKey] = useState(["0"]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showFilter, setShowFilter] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [transactionCurrency, setTransactionCurrency] = useState("");
  const [transactionStatus, setTransactionStatus] = useState("");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [searchLoading, setSearchLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const clientName = CookieUtils.get("clientName");
  const isAvanseClient = clientName !== "STOCKAL";
  const [partner, setPartner] = useState(clientName === "STOCKAL" ? "ALL" : clientName);
  const [partnerList, setPartnerList] = useState([]);
  const isFirstRender = useRef(true);
  const [accountType, setAccountType] = useState( isAvanseClient ? "GLOBAL_LIEN" : "");
  const transactionColumns = [
  {
    Header: "Transaction Number",
    accessor: "transaction_transaction_no",
    search: false,
  },
  {
    Header: "Transaction Type",
    accessor: "transaction_type",
    formatText: true,
    search: false,
  },
  {
    Header: "Partner",
    accessor: "from_account_partner_name",
    formatText: true,
    search: false,
  },
  {
    Header: "Account Type",
    search: false,
    Cell: ({ row }) => {
      const {
        from_account_account_type,
        to_account_account_type,
        card_from_account_account_type,
      } = row.original;

      const value =
        from_account_account_type ||
        to_account_account_type ||
        card_from_account_account_type ||
        "-";
      if (value === "-") return value;
      if (value === "NON_LIEN") {
      return "Unlien";
      }
      return value
        .toLowerCase()
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());
    },
  },
  {
    Header: "From Account Name",
    accessor: "from_account_user_name",
    search: false,
    Cell: ({ row }) => {
      const {
        transaction_type,
        transaction_from_account_desc,
        from_account_user_name,
      } = row.original;

      if (["FUND_RECEIVED", "FUND_RECEIVED_LIEN"].includes(transaction_type)) {
        return transaction_from_account_desc
          ? `${transaction_from_account_desc} (ext)`
          : "-";
      }
       if (transaction_type === "REFUND") {
        return transaction_from_account_desc || "-";
      }
      return from_account_user_name || "-";
    },
  },
  {
    Header: "To Account Name",
    accessor: "to_account_user_name",
    search: false,
     Cell: ({ row }) => {
      const {
        transaction_type,
        transaction_to_account_desc,
        to_account_user_name,
      } = row.original;

      if (transaction_type === "CHARGE") {
        return transaction_to_account_desc
          ? transaction_to_account_desc
          : "-";
      }
      return to_account_user_name || "-";
    },
  },
  {
    Header: "Amount Debited",
    search: false,
    Cell: ({ row }) => {
      const data = row.original;
      const nature = TRANSACTION_NATURE[data.transaction_type];
      const isConversion = data.transaction_type === "CONVERSION";

      if (nature !== "DEBIT" && nature !== "BOTH") return "-";
      if (
        isConversion &&
        transactionCurrency &&
        transactionCurrency !== data.transaction_from_currency
      ) {
        return "-";
      }

      const amount =
        data.transaction_debit_amount ?? data.transaction_amount;

      if (!amount || amount === 0) return "-";

      return `${amount} ${data.transaction_from_currency || ""}`;
    },
  },
  {
    Header: "Amount Credited",
    search: false,
    Cell: ({ row }) => {
      const data = row.original;
      const nature = TRANSACTION_NATURE[data.transaction_type];
      const isConversion = data.transaction_type === "CONVERSION";

      if (nature !== "CREDIT" && nature !== "BOTH") return "-";
      if (
        isConversion &&
        transactionCurrency &&
        transactionCurrency !== data.transaction_to_currency
      ) {
        return "-";
      }

      const amount = data.transaction_amount;

      if (!amount || amount === 0) return "-";

      return `${amount} ${data.transaction_to_currency || ""}`;
    },
  },

  {
    Header: "Status",
    accessor: "transaction_status",
    formatText: true,
    search: false,
  },
  {
    Header: "Created At",
    accessor: "transaction_created_at",
    search: false,
  },
  {
    Header: "View Details",
    accessor: "details",
    search: false,
  },
];
  const fetchAllTransactions = async (page = 1) => {
    try {
      setDataLoading(true);
      setSearchLoading(true);
      const encodedSearch = searchText ? encodeURIComponent(searchText.trim()) : "";

      const formattedStartDate = startDate
        ? format(startDate, "yyyy-MM-dd")
        : "";
        const formattedEndDate = endDate ? format(endDate, "yyyy-MM-dd") : "";
        const partnerValue = clientName === "STOCKAL" ? partner || "ALL" : clientName;
        const response = await mcbAllTransactions(
        encodedSearch, 
        transactionCurrency,
        transactionStatus,
        formattedStartDate,
        formattedEndDate,
        page,
        pageSize,
        accountType === "All" ? "" : accountType ,
        partnerValue
      );

      if (response?.status === 200) {
        const transactionList = response?.data?.data?.transactions || [];
        const count = response?.data?.data?.count || 0;
        setTransactionData(transactionList);
        setTotalRecords(count);
        setTotalPages(Math.ceil(count / pageSize));
        setErrorMessage(null);
      } else {
        setErrorMessage(
          response?.data?.message || "Failed to fetch transaction details"
        );
      }
    } catch (error) {
      setErrorMessage(error?.response?.data?.message || "Something went wrong");
    } finally {
      setDataLoading(false);
      setSearchLoading(false);
    }
  };

  const handleSearch = () => {
    setCurrentPage(1);
    fetchAllTransactions(1);
  };

const getPartnerApi = async () => {
  try {
    const resp = await getUsersPartnerList({ appName: productType.MCB });
    const partners = resp?.data?.data?.map((item) => item?.partnerCd) || [];

    if (clientName === "STOCKAL") {
      setPartnerList(["ALL", ...partners]);
    } else {
      setPartnerList(partners);
    }
  } catch (error) {
    console.error("Error fetching partners", error);
  }
};
const downloadReceipt = async (transactionNo) => {
  if (!transactionNo) return;

  setDownloadLoading(true);
  try {
    const resp = await transactionReportDownload({}, transactionNo);

    if (resp?.status === 200 && resp?.data) {
      const blob = new Blob([resp.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Transaction_Receipt_${transactionNo}.pdf`;
      link.click();

      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error("Receipt Download Error:", error);
  } finally {
    setDownloadLoading(false);
  }
};
  useEffect(() => {
    getPartnerApi();
  }, []);
  const onSubmitFilter = () => {
    if (!startDate || !endDate) {
      setError("Please select dates.");
      return;
    }

    setError("");
    setCurrentPage(1);
    fetchAllTransactions(1);
  };

  useEffect(() => {
    if (isFirstRender.current) return;
    if (searchText.trim()) {               // ✅ added .trim()
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      handleSearch();
    }, 500);
    } else if (
      searchText === "" &&
      !startDate &&
      !endDate &&
      !transactionStatus &&
      !transactionCurrency
    ) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        fetchAllTransactions(1);
      }, 500);
    }

    return () => clearTimeout(timeoutRef.current);
  }, [searchText]);

  const handleToggle = (key) => {
    setActiveKey((prev) =>
      prev.includes(key) ? prev.filter((tab) => tab !== key) : [...prev, key]
    );
  };

  const handleClickRow = async (data) => {
    setCanvasData(null);
    setShowCanvas(true);

    try {
      setCanvasData(data);
    } catch (error) {
      console.error("Error fetching transaction details:", error);
    }
  };


  useEffect(() => {
    if (!showFilter) {
      const newStart = new Date();
      newStart.setMonth(newStart.getMonth() - 1);
      const newEnd = new Date();
      setTransactionCurrency("");
      setTransactionStatus("");
      setAccountType(isAvanseClient ? "GLOBAL_LIEN" : "");
      setStartDate(newStart);
      setEndDate(newEnd);
      setError(null);
      setSearchLoading(false);
      setPartner(clientName === "STOCKAL" ? "ALL" : clientName);
      setCurrentPage(1);
    }
  }, [showFilter]);

  useEffect(() => {
  if (!startDate || !endDate) return;
  const formattedStart = format(startDate, "yyyy-MM-dd");
  const formattedEnd = format(endDate, "yyyy-MM-dd");
  if (searchText !== "") {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      fetchAllTransactions(currentPage, searchText, transactionCurrency, transactionStatus, formattedStart, formattedEnd);
      console.log("Triggered by search");
    }, 500);
  } else {
    fetchAllTransactions(currentPage, searchText, transactionCurrency, transactionStatus, formattedStart, formattedEnd);
  }

    return () => clearTimeout(timeoutRef.current);
  }, [
    currentPage,
    searchText,
    startDate,
    endDate,
    showFilter
  ]);
console.log(canvasData?.to_account_account_no);

  return (
    <div className={styles.container}>
      <SearchFilterBar
        inputText={searchText}
        handleInputChange={(e) => setSearchText(e.target.value)}
        setShowFilter={setShowFilter}
        showFilter={showFilter}
        setInputText={setSearchText}
        placeholder="Search by UserId, Transaction ID, First Name, Username..."
      />
      {showFilter && (
        <Card className={styles.customCard}>
          <Card.Body className={styles.customCardBody}>
            <Filter
              partner={partner}
              setPartner={setPartner}
              partnerList={partnerList}
              showPartner={true}
              transactionCurrency={transactionCurrency}
              setTransactionCurrency={setTransactionCurrency}
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              onSearch={onSubmitFilter}
              loading={searchLoading}
              errorMessage={error}
              transactionStatus={transactionStatus}
              setTransactionStatus={setTransactionStatus}
              showTransactionStatus={true}
              showTransactionCurrency={true}
              showAccountStatus={false}
              accountType={accountType}
              setAccountType={setAccountType}
              showAccountType={true}
              disableAccountType={isAvanseClient}
            />
          </Card.Body>
        </Card>
      )}

      <div className={styles.dataTableContainer}>
        {dataLoading ? (
          <div>
            <CustomSpinner />
          </div>
        ) : (
          <>
            {errorMessage ? (
              <div className={styles.noDataContainer}>
                <div className={styles.noData}>{errorMessage}</div>
              </div>
            ) : transactionData && transactionData.length > 0 ? (
              <DataTable
                columns={transactionColumns}
                list={transactionData}
                rowClick={true}
                handleClickRow={handleClickRow}
                totalPages={totalPages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pagination={true}
                title="Transactions"
              />
            ) : (
              <div className={styles.resultContainer}>
                <Result
                  icon={<NoDataFound width={80} height={80} />}
                  title="No Data Found"
                  subtitle="Your Data will be displayed here"
                />
              </div>
            )}
          </>
        )}
      </div>

      <Offcanvas
        show={showCanvas}
        onHide={() => setShowCanvas(false)}
        placement="end"
        className={styles.offcanvas}
        backdropClassName={styles.backgroundBlur}
        style={{ color: "white" }}
      >
        <Offcanvas.Header
          closeButton
          style={{
            backgroundColor: "#343434",
            color: "white",
            fontSize: "15px",
            height: "50px",
          }}
        >
          <Offcanvas.Title
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              Transaction Details

              <div className={styles.downloadContainer}>
               {canvasData?.transaction_transaction_no &&(
                canvasData?.transaction_type === "CONVERSION" || (
                canvasData?.transaction_type === "TRANSFER" &&
                canvasData?.to_account_account_no?.trim())) &&
                canvasData?.transaction_status !== "FAILED" &&
                canvasData?.transaction_status !== "REJECTED" && (
                    <span
                      className={styles.DownloadButton}
                      onClick={(e) => {
                        e.stopPropagation();
                        downloadReceipt(
                          canvasData.transaction_transaction_no
                        );
                      }}
                    >
                      {downloadLoading ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          className={styles.spinnerButton}
                        />
                      ) : (
                        <img
                          src={download}
                          alt="download"
                          className={styles.iconButton}
                        />
                      )}
                      {" "}Download Receipt
                    </span>
                  )}
              </div>
            </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {canvasData ? (
            <Accordion
              activeKey={activeKey}
              className={styles.accordionContainer}
            >
              <Accordion.Item eventKey="0">
                <Accordion.Header className={styles.accordionHeader}>
                  Main Details
                </Accordion.Header>
                <Accordion.Body className={styles.accordionBody}>
                  <TransactionMainDetail canvasData={canvasData} />
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1" style={{ marginTop: "20px" }}>
                <Accordion.Header
                  onClick={() => handleToggle("1")}
                  className={styles.accordionHeader}
                >
                  Other Details
                </Accordion.Header>
                <Accordion.Body className={styles.accordionBody}>
                  <TransactionOtherDetail canvasData={canvasData} />
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          ) : (
            <div
              style={{
                height: "100%",
                textAlign: "center",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CustomSpinner />
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default Transactions;
